export default "__VITE_ASSET__e1a0398a__"